<template>
  <div>
    用户管理协议
  </div>
</template>

<script>
  export default {
    name: 'SettingsUser'
  }
</script>

<style scoped>

</style>
